define('viewmodels/Weightings_Thresholds/AMLOrganizationalLevelWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'AMLOrganizationalLevelWeightings';
    var AOLWViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        RiskAreaTabClick: RiskAreaTabClick,
        RiskLevelTabClick: RiskLevelTabClick,
        GetRiskLevelSubtabs: GetRiskLevelSubtabs,
        saveBULWeightings: saveBULWeightings,
        saveConBULWeightings: saveConBULWeightings,
        copyData: copyData,
        SaveWeightings: SaveWeightings,
        SaveActualButtonClick: ko.observable(false),
        GetRiskLevelDetails: GetRiskLevelDetails,
        clickedlevel: ko.observable(),
        ClickedLeve2Id: ko.observable(),
        ClickedLevel3Id: ko.observable(),
        addNewDivTabBULevel: addNewDivTabBULevel,
        BusinessLevelDetailTabClick: BusinessLevelDetailTabClick,
        BusinessLevelList: ko.observableArray(),
        ClickedType: ko.observable(),
        saveBULWeightings: saveBULWeightings,
        BusinessLevelDetailsList: ko.observableArray(),
        BusinessUnitsLowestLevelList: ko.observableArray(),
        ClickedLevelDetailId: ko.observable(),
        BULWeightingsList: ko.observable(),
        ClickedLevelDetailName: ko.observable(),
        RiskAreaList: ko.observable(),
        BULWeightingsListSave: ko.observableArray(),
        ControlAreaList: ko.observableArray(),
        GetAllControlArea: GetAllControlArea,
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        countLevelEntry: ko.observable(0),
        LevelErrorStatus: ko.observable(0),
        RiskAreaTabClicked: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        PreviousClickedAreaID: ko.observable(),
        PreviousLevelID: ko.observable(),
        countLevelDetailEntry: ko.observable(),
        PreviousLevelDetailID: ko.observable(),
        LevelIDForSproc: ko.observable(),
        ScreenName: ko.observable(),
        AssessmentTypeId: ko.observable(),
        AssessmentType: ko.observable(),
        WeightingsGridList: ko.observableArray([]),
        WeightingsBUDataList: ko.observableArray([]),
        RAId: ko.observable(),
        ClickedCompType: ko.observable("INH"),
        OrgLevelMapList: ko.observableArray([]),
        OrgSelectedValue: ko.observable(0),
        OrgLevelChange: OrgLevelChange,
        PreviousSavedDetailId: ko.observable(0),
        PreviousSavedFlag: ko.observable(false),
        BusinessUnitsListW: ko.observableArray([]),
        WeightingsDataList: ko.observableArray([]),
    }

    return AOLWViewModel;
    function activate() {
        var Id = AOLWViewModel.appsecurity.getParameterByName('atype');
        AOLWViewModel.AssessmentTypeId(Id);
        AOLWViewModel.RAId(Id);
        AOLWViewModel.appsecurity.GetAssessmentNames().then(function () {

            AOLWViewModel.AssessmentType(AOLWViewModel.appsecurity.GetAssessmentName(AOLWViewModel.AssessmentTypeId()))
            AOLWViewModel.ScreenName(AOLWViewModel.AssessmentType() + '  Organizational Level Weightings');
        });

        AOLWViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
            AOLWViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                if (AOLWViewModel.appsecurity.isConfigurationFreeze() == 1)
                    AOLWViewModel.appsecurity.WriteAccess(false);
            });
        });
    }
    function attached() {
        try {
            
            $("#WeightingsTableBU").hide();
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');

            var url = window.location.pathname;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "AMLOrganizationalLevelWeightings") {
                $(document).on('change', 'input', function (e) {
                    GetTotalWeightings();
                });
            }
            $('#RaAMLTab').tabs();
            $('#RaAMLTab').tabs('refresh');
            $('#RaAMLTab').tabs({ active: 0 });
            scrollableTabs();

            $(document).on('keydown', 'input', function (e) {
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0, columns=0;
                if ((id.substring(0, 25)) == "txt_weightingAMLControls_") {
                    result = id.substring(("txt_weightingAMLControls_").length, id.length);
                    controlID = 'txt_weightingAMLControls_';
                    rows = AOLWViewModel.BusinessUnitsListW().length;
                    columns = AOLWViewModel.ControlAreaList().length;  
                }

                if (e.which == 9 && filename == "AMLOrganizationalLevelWeightings" && rows > 1) {
                    var columnandrownuo = result.indexOf("_");

                    if (controlID == "txt_weightingAMLControls_") {
                        var rowno  = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    }

                    var lineno = 0;
                    for (var l = 0; l < AOLWViewModel.BusinessUnitsListW().length - 1; l++) {
                        if (AOLWViewModel.BusinessUnitsListW()[l].BusinessUnit_ID() == rowno) {
                            rowno = AOLWViewModel.BusinessUnitsListW()[l + 1].BusinessUnit_ID();
                            break;
                        }

                        if (l + 2 == rows) {
                            lineno = rows;  //15 was added
                        }
                    }

                    if (lineno == rows) {
                        for (var k = 0; k < AOLWViewModel.ControlAreaList().length - 1; k++) {
                            if (AOLWViewModel.ControlAreaList()[k].ControlAreaId() == columnno) {
                                columnno = AOLWViewModel.ControlAreaList()[k + 1].ControlAreaId();
                                rowno = AOLWViewModel.BusinessUnitsListW()[0].BusinessUnit_ID();
                                break;
                            }
                        }
                    }
                    for (var i = rowno; i < rows; i++) {
                        if (controlID == "txt_weightingAMLControls_") {
                            var tobefocusedid = controlID + rowno + "_" + columnno;
                        }

                        if ($("#" + tobefocusedid).prop('disabled')) {
                            rowno = rowno + 1;
                        }
                        else {
                            break;
                        }
                    }
                    if (rows == rowno | columnandrownuo == -1 | isNaN(columnno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else if (controlID == "txt_weightingAMLControls_") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno;
                        if ($("#" + tobefocusedid).prop('disabled')) {

                        }
                        else {
                            $("#" + tobefocusedid).focus();
                            $("#" + tobefocusedid).select();
                        }
                    }
                }
            });
            $($('#RiskAreaAMLUl li').get(0)).trigger('click');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    };
    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    };


    //Tab click Events
    function InputChange() {
        AOLWViewModel.InputChangeEvent(true);
    }
    function RiskAreaTabClick(data, event, flag) {
        try {
            $('#RdAMLTab').show();
            $('#RfAMLTab').show();
            if (flag == undefined)
                flag = 0;

            if (AOLWViewModel.appsecurity.WriteAccess() == false || AOLWViewModel.appsecurity.WriteAccess() == "false") {
                flag = 0;
            }
            if (flag == 0) {
                flag = 1;
                if (event.currentTarget.id == 'AMLinherent') {
                    $('#AMLControls').removeClass('ui-tabs-active');
                    $('#AMLControls').removeClass('ui-state-active');
                    AOLWViewModel.ClickedType("Inherent");
                    AOLWViewModel.ClickedCompType("INH");
                    AOLWViewModel.clickedlevel("AML Inherent Risk");
                }
                else if (event.currentTarget.id == 'AMLControls') {
                    $('#' + event.currentTarget.id).addClass('ui-tabs-active');
                    $('#' + event.currentTarget.id).addClass('ui-state-active');
                    $('#AMLinherent').removeClass('ui-tabs-active');
                    $('#AMLinherent').removeClass('ui-state-active');
                    AOLWViewModel.ClickedType("Controls");
                    AOLWViewModel.ClickedCompType("CTRL");
                    AOLWViewModel.clickedlevel("AML Controls");
                    AOLWViewModel.PreviousClickedAreaID(event.currentTarget.id);
                }
                $('#' + event.currentTarget.id).addClass('ui-tabs-active');
                $('#' + event.currentTarget.id).addClass('ui-state-active');
                AOLWViewModel.PreviousClickedAreaID(event.currentTarget.id);
             //  AOLWViewModel.RAId(event.currentTarget.id);
                GetRiskLevelDetails();
            }
            else if ((AOLWViewModel.InputChangeEvent() || AOLWViewModel.CopyDataButtonClicked()) && AOLWViewModel.SaveButtonClick() == false) {
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        AOLWViewModel.SaveActualButtonClick(false);
                        saveConBULWeightings();
                        //AOLWViewModel.countEntry(0);
                        if (AOLWViewModel.ErrorStatus() == 1) {
                            AOLWViewModel.ErrorStatus(0);
                            $('#' + AOLWViewModel.PreviousClickedAreaID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + event.currentTarget.id).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            AOLWViewModel.SaveButtonClick(false);
                            flag = 0;
                            $('#' + AOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                            RiskAreaTabClick(data, event);
                        }
                    }
                    else if (AOLWViewModel.ErrorStatus() == 0) {
                      flag = 1;
                        AOLWViewModel.ErrorStatus(1);
                        $('#' + AOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                        RiskAreaTabClick(data, event, flag);
                    }
                });
            }
            else {
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                AOLWViewModel.SaveButtonClick(false);
                flag = 0;
                $('#' + AOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                RiskAreaTabClick(data, event,flag);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelTabClick(data, event) {
        try {
            AOLWViewModel.ClickedLeve2Id(data.BlName);
            if (AOLWViewModel.appsecurity.WriteAccess() == false || AOLWViewModel.appsecurity.WriteAccess() == "false") {
                AOLWViewModel.countLevelEntry(0);
            }
            if (AOLWViewModel.countLevelEntry() == 0) {
                AOLWViewModel.countLevelEntry(1);
                var x = data.Bulevel.substring(2, 3);
                GetRiskLevelSubtabs(data.Bulevel, x);
            }
            else if ((AOLWViewModel.InputChangeEvent() || AOLWViewModel.CopyDataButtonClicked()) && AOLWViewModel.SaveButtonClick() == false) {
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"])
                .then(function (option) {
                    if (option == "Save") {
                        AOLWViewModel.SaveActualButtonClick(false);
                        saveConBULWeightings();
                        if (AOLWViewModel.ErrorStatus() == 1) {
                            AOLWViewModel.ErrorStatus(0);
                            $('#' + AOLWViewModel.PreviousLevelID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            AOLWViewModel.SaveButtonClick(false);
                            AOLWViewModel.countLevelEntry(0);
                            $('#RfAMLTab ul li #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                            $('#RfAMLTab ul li #' + AOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                            RiskLevelTabClick(data, event);
                        }
                    }
                    else {
                        AOLWViewModel.SaveButtonClick(false);
                        AOLWViewModel.countLevelEntry(0);
                        $('#RfAMLTab ul #' + AOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                        $('#RfAMLTab ul #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                        RiskLevelTabClick(data, event);
                    }
                });
            }
            else {
                AOLWViewModel.SaveButtonClick(false);
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                AOLWViewModel.countLevelEntry(0);
                $('#RfAMLTab ul #' + AOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                $('#RfAMLTab ul #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                RiskLevelTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetOrganizationalList() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetOrganizationalList",
                data: {
                    "RiskAreaType": AOLWViewModel.AssessmentTypeId(), "DeUid": AOLWViewModel.ClickedLevelDetailId(),
                    "ComponentType": AOLWViewModel.ClickedCompType()
                },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
         .success(ajaxSuccess)
         .fail(ajaxFail);

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        AOLWViewModel.OrgLevelMapList([]);
                        var mappedAllRiskLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelDetail(result);
                        });
                        AOLWViewModel.OrgLevelMapList(mappedAllRiskLevels);
                        
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AOLWViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOrganizationalList() method in AMLOrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOrganizationalList() method in AMLOrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOrganizationalList() method in AMLOrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetOrganizationalList() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BusinessLevelDetailTabClick(data, event) {
        try {
            
            $('#loadingMainDivOrgLevel_AML').show();
            $('#WeightingsTableBU').hide();
            AOLWViewModel.BusinessLevelDetailsList();
            AOLWViewModel.ClickedLevelDetailId(data.DetailId);
           
            var detailName = data.DetailName;
           // AOLWViewModel.ClickedLevelId(detailName);
            if (AOLWViewModel.appsecurity.WriteAccess() == false || AOLWViewModel.appsecurity.WriteAccess() == "false") {
                AOLWViewModel.countLevelDetailEntry(0);
            }
            if (AOLWViewModel.countLevelDetailEntry() == 0) {
                AOLWViewModel.countLevelDetailEntry(1);
                AOLWViewModel.ClickedLevelDetailId(data.DetailId);
                AOLWViewModel.ClickedLevelDetailName(data.DetailName);

                GetOrganizationalList();
                GetCULevelWeightings();
            }
            else if ((AOLWViewModel.InputChangeEvent() || AOLWViewModel.CopyDataButtonClicked()) && AOLWViewModel.SaveButtonClick() == false) {
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        AOLWViewModel.SaveActualButtonClick(false);
                        saveConBULWeightings();
                        //AOLWViewModel.countEntry(0);
                        if (AOLWViewModel.ErrorStatus() == 1) {
                            AOLWViewModel.ErrorStatus(0);
                            $('#' + AOLWViewModel.PreviousLevelDetailID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.DetailId).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            AOLWViewModel.SaveButtonClick(false);
                            AOLWViewModel.countLevelDetailEntry(0);
                            $('#RdAMLTab ul li #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                            $('#RdAMLTab ul li #' + AOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                            BusinessLevelDetailTabClick(data, event);
                        }
                    }
                    else {
                        AOLWViewModel.SaveButtonClick(false);
                        AOLWViewModel.countLevelDetailEntry(0);
                        $('#RdAMLTab ul #' + AOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                        $('#RdAMLTab ul #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                        BusinessLevelDetailTabClick(data, event);
                    }
                });
            }
            else {
                AOLWViewModel.InputChangeEvent(false);
                AOLWViewModel.CopyDataButtonClicked(false);
                AOLWViewModel.SaveButtonClick(false);
                AOLWViewModel.countLevelDetailEntry(0);
                $('#RdAMLTab ul #' + AOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                $('#RdAMLTab ul #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                BusinessLevelDetailTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }

    }


    function OrgLevelChange() {
        try {
            
            $('#loadingMainDivOrgLevel_AML').show();
            $('#WeightingsTableBU').hide();
            //            AOLWViewModel.OrgSelectedValue();
            if ($("#OrganizationalLevelId").val() == '') {
                return false;
            }
            else {
                GetCULevelWeightings();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrgLevelChange() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }

	function GetTotalControlWeightingsBUL() {
		
        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < AOLWViewModel.ControlAreaList().length; k++) {

            var sum = parseFloat(0);
            for (var i = 0; i < AOLWViewModel.BusinessUnitsLowestLevelList().length; i++) {

                var x = "#txt_BULweightingCon" + i + "_" + k + "_" + AOLWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k;
            if (isNaN(sum)) {
                $("#txt_BULweightingCon" + rowcount + AOLWViewModel.ClickedLevelDetailId()).val(0);
            }
            else {
                $("#txt_BULweightingCon" + rowcount + AOLWViewModel.ClickedLevelDetailId()).val(parseFloat(sum).toFixed(2));
            }

            if (sum == 100) {
                $("#txt_BULweightingCon" + rowcount + AOLWViewModel.ClickedLevelDetailId()).css('color', '#000000');
                $("#txt_BULweightingCon" + rowcount + AOLWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc");
            }
            else {
                $("#txt_BULweightingCon" + rowcount + AOLWViewModel.ClickedLevelDetailId()).css('color', 'red');
            }
        }
    }

	function GetTotalWeightings() {
	    try {
	        for (var i = 0; i < AOLWViewModel.ControlAreaList().length; i++) {
	            var sum = parseFloat(0);
	            for (var k = 0; k < AOLWViewModel.BusinessUnitsListW().length; k++) {
	                var x = "#txt_weightingAMLControls_" + AOLWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID() + "_" + AOLWViewModel.ControlAreaList()[i].ControlAreaId();
	                sum = parseFloat(sum) + parseFloat($(x).val());
	            }
	            var colcount = AOLWViewModel.ControlAreaList()[i].ControlAreaId();
	            if (isNaN(sum)) {
	                $("#txt_weightingAMLControls_" + colcount).val(0);
	            }
	            else {
                    $("#txt_weightingAMLControls_" + colcount).val(parseFloat(sum).toFixed(2));
	            }
	            if (sum == 100) {
	                $("#txt_weightingAMLControls_" + colcount).css('color', '#000000')
	                $("#txt_weightingAMLControls_" + colcount).css("background-color", "#cccccc")
	            } else {
	                $("#txt_weightingAMLControls_" + colcount).css('color', 'red')
	            }
	        }
	    }
	    catch (e) {
	        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTotalWeightings() method in AMLControlsWeightings.js';
	        logger.logMessage(msg);
	    }
	}

    function addNewDivTabBULevel(BuDetailId) {
        try {
            $('#WeightingsTableBU').empty();
            $('#WeightingsTableBU').append(
          '<div id="AMLTabDiv-' + BuDetailId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addNewDivTabBULevel() method in AMLOrganizationalLevelWeightings.js.js';
            logger.logMessage(msg);
        }
    }
    function GetAllControlArea() {
        try {
            $.ajax({
                url: "/api/ControlArea/GetAllControlArea?Type=" + AOLWViewModel.AssessmentTypeId(),
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllControlArea() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedAllRiskLevels = $.map(jsonResult, function (result) {
                        return new ControlAreas(result);
                    });
                    AOLWViewModel.ControlAreaList(mappedAllRiskLevels);
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AOLWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetAllFinalRiskLevel() method in AMLOrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLOrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLOrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function GetRiskLevelDetails() {
        try {
            $.ajax({
                url: "/api/Configuration/getAllDistinctBusinessLevels ",
                type: "GET",
                //async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    var MappedBUModelList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });
                    AOLWViewModel.BusinessLevelList(MappedBUModelList);
                    $('#RdAMLTab').show();
                     $('#RfAMLTab').show();
                    $('#RfAMLTab').tabs();
                    $('#RfAMLTab').tabs('refresh');
                    $('#RfAMLTab').tabs({ active: 0 });
                    $($('#RiskFactorUl li').get(0)).trigger('click');
                }
                else {
                    app.showMessage("Organizational Levels configurations not in place", "Error", ["OK"]);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in AMLOrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLOrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLOrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function GetRiskLevelSubtabs(FullLevelID, LevelID) {
        try {
            AOLWViewModel.PreviousLevelID(FullLevelID);
            for (var i = 0; i < AOLWViewModel.BusinessLevelList().length ; i++) {
                if (AOLWViewModel.BusinessLevelList()[i].Bulevel == AOLWViewModel.PreviousLevelID()) {
                    AOLWViewModel.LevelIDForSproc(AOLWViewModel.BusinessLevelList()[i].BlId);
                }
            }
            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": AOLWViewModel.LevelIDForSproc() },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (!(jsonResult == "")) {


                    if (jsonResult != null && jsonResult[0].BuLevelDetailName != null) {
                        $('#NoSublevels').hide();
                        $('#RdAMLTab').show();
                        var mappedBULevelsList = $.map(jsonResult, function (result) {
                            return new BusinessLevelDetail(result);
                        });
                        AOLWViewModel.BusinessLevelDetailsList(mappedBULevelsList);
                        $('#RdAMLTab').tabs()
                        $('#RdAMLTab').tabs('refresh');
                        $('#RdAMLTab').tabs({ active: 0 });
                        $($('#RiskLevelDetailAMLUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AOLWViewModel), true);
                }
                else {
                    $('#NoSublevels').show();
                    $('#RdAMLTab').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }




    }
   
    function GetAllRiskAreas() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllRiskArea12", 
                data: {
                    "AreaType": "ALL", "AssessmentTypes": AOLWViewModel.AssessmentTypeId(), "ScreenType": 'IW', "ParentAreaId": "NULL", "TypeId": "NULL", "SurveyCategoryID": "NULL"
                },    
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
        .fail(ajaxFail);


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskAreas() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "" && jsonResult[0].RiskAreaName != null) {
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;
                    });
                    AOLWViewModel.RiskAreaList([]);
                    AOLWViewModel.RiskAreaList(mappedRiskAreaList);

                }
                else {
                    app.showMessage("Risk Area configurations not in place.", "Error", ["OK"]);
                    $('#NoRiskAreaserrorORGAML').show();
                    $("#RaAMLTab").hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        };
    };
    function GetCULevelWeightings() {
		try {
		    
		    
		    var orgeLevelId = $("#OrganizationalLevelId option:selected").val();
		   
		    if (AOLWViewModel.PreviousSavedFlag() == true){
		        orgeLevelId = AOLWViewModel.PreviousSavedDetailId();
		        $("#OrganizationalLevelId").val(AOLWViewModel.PreviousSavedDetailId());
		    } else if (orgeLevelId == "" || orgeLevelId == undefined) {
                $("#OrganizationalLevelId").val("0");
                orgeLevelId = "0";
		    }

            $.ajax({
				url: "/api/WeightingsThresholds/GetOrgLevelWeightings",
				data: { "RiskAreaType": AOLWViewModel.AssessmentTypeId(), "DeUid": AOLWViewModel.ClickedLevelDetailId(),
				    "ComponentType": AOLWViewModel.ClickedCompType(), "UpdatedOption": orgeLevelId
				},
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    
                        AOLWViewModel.ControlAreaList([]);
                        var mappedControlAreas = $.map(jsonResult.AreasList, function (result) {
                            return new ControlAreas(result);
                        });
                        AOLWViewModel.ControlAreaList(mappedControlAreas);

                        AOLWViewModel.BusinessUnitsListW([]);
                        var MappedBUModelList = $.map(jsonResult.BUList, function (result) {
                            return new BusinessUnitModel(result);
                        });
                        AOLWViewModel.BusinessUnitsListW(MappedBUModelList);

                        $('#WeightingsTableBU').show();
                        
                        if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                            var tableObj = $('#WeightingsTable').DataTable();
                            tableObj.fixedHeader.disable();
                            tableObj.destroy();
                            $('#WeightingsTable tbody tr').remove();
                            $("#trOneW > th").remove();
                            $("#trTwoW > th").remove();
                            var htmlHeaders = "";

                            htmlHeaders += '<th class="" style=""><span class="glyphicon glyphicon-arrow-down"></span>Business Unit Name / <span class="glyphicon glyphicon-arrow-right"></span>Risk Area Name</th>'
                            for (var i = 0; i < AOLWViewModel.ControlAreaList().length; i++) {
                                htmlHeaders += '<th style="text-align:center;vertical-align:middle;" title="' + AOLWViewModel.ControlAreaList()[i].ControlAreaNameTitle() + '" class="noSort" data-bind="text: ' + AOLWViewModel.ControlAreaList()[i].ControlAreaName() + ', attr:{id: ' + AOLWViewModel.ControlAreaList()[i].ControlAreaId() + ', \'title\': ' + AOLWViewModel.ControlAreaList()[i].ControlAreaNameTitle() + '}, css:{\'long header-ellipsis\': true}">' + AOLWViewModel.ControlAreaList()[i].ControlAreaName() + '</th>'
                            }
                            $("#trOneW").append(htmlHeaders);

                            var htmlHeaders1 = "";
                            htmlHeaders1 += '<th class="noSort" style="border-bottom: unset !important;font-weight:700;text-align: left;vertical-align:middle;background-color:#00a3e0;">Total</th>'
                            for (var i = 0; i < AOLWViewModel.ControlAreaList().length; i++) {
                                htmlHeaders1 += '<th class="noSort" style="text-align:center;vertical-align:middle;background-color:white;border: 1px solid #ccc !important;">'
                                htmlHeaders1 += '<div class="input-group" style="padding: unset !important;text-align:center;vertical-align:middle;margin-bottom:unset;">'
                                htmlHeaders1 += '<input type="text" disabled style="font-weight: 600;position:unset !important;background-color:#cccccc;" class="form-control inputWBU" id="txt_weightingAMLControls_' + AOLWViewModel.ControlAreaList()[i].ControlAreaId() + '" }">'
                                htmlHeaders1 += '<span class="input-group-addon">%</span>'
                                htmlHeaders1 += ' </div>'
                                htmlHeaders1 += '</th>'
                            }
                            $("#trTwoW").append(htmlHeaders1);

                        }
                        AOLWViewModel.WeightingsDataList([]);
                        var mappedWeightings = $.map(jsonResult.WeightingsDataList, function (result) {
                            return new WeightingDataModel(result);
                        });
                        AOLWViewModel.WeightingsDataList(mappedWeightings);

                        $('#loadingMainDivOrgLevel_AML').hide();
                        $('#WeightingsTableBU').show();
                        GetTotalWeightings();
                        var oTable = $('#WeightingsTable').DataTable(
                            {
                                'aoColumnDefs': [{
                                    'bSortable': false,
                                    "targets": "_all"
                                    //'aTargets': ['noSort']
                                }],
                                "aaSorting": [],
                                scrollY: "35rem",
                                scrollX: true,
                                scrollCollapse: true,
                                fixedColumns: true,
                                paging: false,
                                "bInfo": false,
                                "bAutoWidth": false,
                                fixedColumns: {
                                    leftColumns: 1
                                },
                                fixedheader: {
                                    header: true
                                },
                            });

                        $('#WeightingsTable').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                      
                    }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function GetBUlevelWeightings() {
		try {
			
            $.ajax({
				url: "/api/WeightingsThresholds/GetBULevelWeightings",
				data: { "RiskAreaType": AOLWViewModel.AssessmentTypeId(), "DeUid": AOLWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelWeighting = 1;
                    AOLWViewModel.BULWeightingsList(mappedWeightings);

                    BULevelWeightingsTable(checkBULevelWeighting);
                    // GetTotalWeightingsBUL();
                }
                else {
                    checkBULevelWeighting = 0;
                    BULevelWeightingsTable(checkBULevelWeighting);
                    //  GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in AML OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function CULevelWeightingsTable(checkBULevelWeighting) {
        try {

            if (AOLWViewModel.BULWeightingsList() == undefined) {
                AOLWViewModel.BULWeightingsList([]);
            }
            var selectedRow, selectedCol;
            var rows = AOLWViewModel.BusinessUnitsLowestLevelList().length;
            var j = AOLWViewModel.ControlAreaList().length;
            for (var i = 0; i < AOLWViewModel.ControlAreaList().length; i++) {
                colHeight = Math.ceil(AOLWViewModel.ControlAreaList()[i].ControlAreaName.length / 25)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            bucoulmnheight = tdHeight / 2;

            for (var i = 0; i < AOLWViewModel.BusinessLevelDetailsList().length; i++) {
                var id = document.getElementById('AMLTabDiv-' + AOLWViewModel.BusinessLevelDetailsList()[i].DetailId);
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + AOLWViewModel.BusinessLevelDetailsList()[i].DetailId).innerHTML = "";
                }
            }
            var TabData =
'<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (AOLWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + AOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + AOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveConBULWeightings" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-4 control-label control-label-border no-padding">' + AOLWViewModel.ClickedLevelDetailName() + '&nbsp<b>&rArr;</b>&nbsp' + AOLWViewModel.ClickedLeve2Id() + '&nbsp<b>&rArr;</b>&nbsp' + AOLWViewModel.ClickedLevel3Id() + '</label>';
            TabData += '</div><label id="lblSANCError-' + AOLWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +

                     //'<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label">' + AOLWViewModel.ClickedLevelDetailName() + '</label>' +
            //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Control Areas</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Business Units</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>';
            //Corner cell end
            //Header Business units
            TabData += '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + AOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
                '<table>' +
                    '<tr>';


            for (var i = 0 ; i < AOLWViewModel.ControlAreaList().length; i++) {
                TabData += '<td  style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + AOLWViewModel.ControlAreaList()[i].ControlAreaId + '" title="' + AOLWViewModel.ControlAreaList()[i].ControlAreaName + '">' + AOLWViewModel.ControlAreaList()[i].ControlAreaName + '</td>';
            }
            TabData += '</tr>' +
                              '</table>' +
                             '</div>';
            //Header Business units end
            //Row headers
            TabData += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + AOLWViewModel.ClickedLevelDetailId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < rows; i++) {
                selectedRow = AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                TabData += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                TabData += AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                TabData += '</td></tr>';
            }
            TabData += '</table></div>';

            //Row headers end
            //data starts
            TabData += '<div class="wclscscroll table-content" id="clscroll-content' + AOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
    '<table id="tblConWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId() + '"><tbody>';
            for (var i = 0; i < rows; i++) {
                selectedRow = AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                TabData += '<tr id="' + AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID + '">';
                for (var k = 0; k < (j) ; k++) {
                    TabData += '<td id="' + AOLWViewModel.ControlAreaList()[k].ControlAreaId + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    selectedCol = AOLWViewModel.ControlAreaList()[k].ControlAreaId;
                    if (AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() == 'NOT APPLICABLE') {

                        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        AOLWViewModel.BULWeightingsList().push(newObj);
                        TabData += '<input type="text" disabled  class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + AOLWViewModel.ClickedLevelDetailId() + '" value="0" style="background-color: #ccc;"></input><span class="input-group-addon">%</span>';
                        TabData += '</div></td>';
                    }
                    else {
                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < AOLWViewModel.BULWeightingsList().length; val++) {
                                if (AOLWViewModel.BULWeightingsList()[val].Id == AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID && AOLWViewModel.BULWeightingsList()[val].BuId == AOLWViewModel.ControlAreaList()[k].ControlAreaId) {


                                    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULweightingCon' + i + '_' + k + '_' + AOLWViewModel.ClickedLevelDetailId() + '" value="' + AOLWViewModel.BULWeightingsList()[val].WeightingValue + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                AOLWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + AOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            AOLWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + AOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                    }
                }
                TabData += '</tr>'
            }
            TabData += '</tbody></table></div>';
            //Data ends
            //Total  cell

            TabData += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabData += "Total"
            TabData += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>';
            //Total cell end
            //Total Data
            TabData += '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + AOLWViewModel.ClickedLevelDetailId() + '">' +
                 '<table>' +
                     '<tr>'
            for (l = 0; l < AOLWViewModel.ControlAreaList().length; l++) {
                TabData += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabData += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_BULweightingCon' + l + AOLWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                TabData += '</td>';
            }
            TabData += '</tr>' +
            '</table>'

            document.getElementById('AMLTabDiv-' + AOLWViewModel.ClickedLevelDetailId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnSANCSave-' + AOLWViewModel.ClickedLevelDetailId()), { click: AOLWViewModel.saveConBULWeightings }, AOLWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + AOLWViewModel.ClickedLevelDetailId()), { click: AOLWViewModel.copyData }, AOLWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_BULweightingCon' + i + '_' + k + '_' + AOLWViewModel.ClickedLevelDetailId()), { event: { keyup: AOLWViewModel.InputChange } }, AOLWViewModel);

                }
            }
            GetTotalControlWeightingsBUL();
            ImplementControlsSecurity();
            $("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-row-headers" + AOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollTop());
                $("#clscroll-column-headers" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft());
                $("#clscroll-column-footer" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-headers" + AOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-headers" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-footer" + AOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-footer" + AOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-row-headers" + AOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + AOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-row-headers" + AOLWViewModel.ClickedLevelDetailId()).scrollTop());
            });
            $('#loadingMainDivOrgLevel_AML').hide();
            $('#WeightingsTableBU').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CULevelWeightingsTable() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------------------------------------->

    function MapWeightingsBUDataList(checkWeighting) {
        try {
          
            AOLWViewModel.WeightingsGridList([]);
            if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                tableObj = $('#WeightingsTable1').DataTable();
                tableObj.destroy();
                $('#WeightingsTable1 tbody tr').remove();

            }
            //GetAllRiskAreas();
            for (var i = 0; i < AOLWViewModel.BusinessUnitsLowestLevelList().length; i++) {
                for (var k = 0; k < AOLWViewModel.RiskAreaList().length; k++) {

                    if (checkWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < AOLWViewModel.BULWeightingsList().length; val++) {
                            if (AOLWViewModel.BULWeightingsList()[val].BuId == AOLWViewModel.RiskAreaList()[k].RiskAreaId && AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() == 'NOT APPLICABLE') {

                                var newObj = new WeightingModel({ 'Id': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID, 'Name': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name, 'BuId': AOLWViewModel.RiskAreaList()[k].RiskAreaId, 'WeightingValue': 0, 'BuStatus': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus });

                                AOLWViewModel.WeightingsGridList().push(newObj);                                        // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //AIWViewModel.WeightingsList().push(newObj);
                                //   TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (AOLWViewModel.BULWeightingsList()[val].Id == AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID && AOLWViewModel.BULWeightingsList()[val].BuId == AOLWViewModel.RiskAreaList()[k].RiskAreaId) {

                                var newObj = new WeightingModel({ 'Id': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID, 'Name': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name, 'BuId': AOLWViewModel.RiskAreaList()[k].RiskAreaId, 'WeightingValue': AOLWViewModel.BULWeightingsList()[val].WeightingValue, 'BuStatus': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() });

                                AOLWViewModel.WeightingsGridList().push(newObj);
                                //   TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="' + AIWViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            var newObj = new WeightingModel({ 'Id': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID, 'Name': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name, 'BuId': AOLWViewModel.RiskAreaList()[k].RiskAreaId, 'WeightingValue': 0, 'BuStatus': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() });

                            AOLWViewModel.WeightingsGridList().push(newObj);
                        
                        }
           
                    }
                    else {
                        var newObj = new WeightingModel({ 'Id': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID, 'Name': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name, 'BuId': AOLWViewModel.RiskAreaList()[k].RiskAreaId, 'WeightingValue': 0, 'BuStatus': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() });

                        AOLWViewModel.WeightingsGridList().push(newObj);
                        //    var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        //    AIWViewModel.WeightingsList().push(newObj);
                        //    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        //}
                    }

                    //  TabData += '</div></td>';


                }
                //TabData += '</tr>';
            }

            var mappedList = ko.observableArray();
            for (var i = 0; i < AOLWViewModel.BusinessUnitsLowestLevelList().length; i++) {
                var weightingsData = ko.utils.arrayFilter(AOLWViewModel.WeightingsGridList(), function (parameter) {
                    if (parameter.Id == AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID)
                        return true;
                    else
                        return false;
                });

                mappedList.push(new BUModel({ 'BusinessUnitId': weightingsData[0].Id, 'BusinessUnitName': weightingsData[0].Name(), 'rowData': weightingsData }));
                //ko.applyBindingsToNode($('#txt_weighting-' + m + AIWViewModel.RAId()), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel);
            }
            AOLWViewModel.WeightingsBUDataList([]);
            AOLWViewModel.WeightingsBUDataList(mappedList());

          //  var a = AOLWViewModel.BusinessUnitsList();
           
            //  $('#divWeightings_BU').show();
            //$('#divControlsWeightings_SBU').hide();
            if ($.fn.dataTable.isDataTable('#WeightingsTable1')) {
                $('#WeightingsTable1').DataTable().destroy();
            }
            var a = AOLWViewModel.RiskAreaList();
            var oTable = $('#WeightingsTable1').DataTable(
                {
                    "bSort": false,
                    scrollY: "38rem",
                    scrollX: true,
                    scrollCollapse: true,
                    "bAutoWidth": false,
                    bFilter: false,
                    paging: false,
                    "bInfo": false,

                    fixedHeader: {
                        header: true
                    },
                    fixedColumns: {
                        leftColumns: 1
                    }
                });

            $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");
            //GetTotalWeightingsBUL();


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }




    function ImplementControlsSecurity() {
        try {
            if (AOLWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblConWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblConWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementSecurity() {
        try {
            if (AOLWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSACNWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblSACNWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in AMLOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BUModel(item) {
        try {
            var self = this;
            self.BusinessUnitId = ko.observable(item.BusinessUnitId);
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName).text());
            self.rowData = item.rowData;
        }
        catch (e) {
            var msg = 'exception' + e + 'source: AreaModel() in AmlControlRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }


    function copyData() {
            try {
                $('#loadingMainDivOrgLevel_AML').show();
                AOLWViewModel.CopyDataButtonClicked = ko.observable(true).extend({ notify: 'always' });
                
                $("#lblErrorAMLControls").hide();
                var valid = 0;
                var selectedRowId = 0;
                var selectedColId = 0;
                var wValue = 0;
                var sum = 0;
                var rows = AOLWViewModel.BusinessUnitsListW().length; 
                var cols = AOLWViewModel.ControlAreaList().length;
                var weightingsvaluearray = []

                for (var i = 0; i < AOLWViewModel.ControlAreaList().length; i++) {
                    if (i == 0) {
                        for (var k = 0; k < AOLWViewModel.BusinessUnitsListW().length; k++) {
                            var txtValue = $("#txt_weightingAMLControls_" + AOLWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID() + "_" + AOLWViewModel.ControlAreaList()[i].ControlAreaId()).val();

                            if (txtValue == "") {
                                $("#lblErrorAMLControls").show();
                                $("#lblErrorAMLControls").text('Cell cannot be left blank.');
                                valid = 1;
                                $('#loadingMainDivOrgLevel_AML').hide();
                                break;
                            }
                            else {
                                var txt = parseFloat(txtValue);
                                if (!$.isNumeric(txt)) {
                                    $("#lblErrorAMLControls").show();
                                    $("#lblErrorAMLControls").text('Non-numeric entry is not allowed.');
                                    valid = 1;
                                    $('#loadingMainDivOrgLevel_AML').hide();
                                    break;
                                }
                                else if (txt < 0 || txt > 100) {
                                    $("#lblErrorAMLControls").show();
                                    $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                                    valid = 1;
                                    $('#loadingMainDivOrgLevel_AML').hide();
                                    break;
                                }
                                else {
                                    weightingsvaluearray.push(txt);
                                    sum += txt;
                                }
                            }
                        }
                    }
                }

                if (valid == 1) {
                    AOLWViewModel.ErrorStatus(1);
                }
                if (valid == 0) {            
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = AOLWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID(); 
                        for (var j = 0; j < cols; j++) {
                            selectedColId = AOLWViewModel.ControlAreaList()[j].ControlAreaId();
                            for (var k = 0; k < AOLWViewModel.WeightingsDataList().length; k++) {
                                if (selectedRowId == AOLWViewModel.WeightingsDataList()[k].BuId()) {
                                    var buList = AOLWViewModel.WeightingsDataList()[k].AreasCountList;
                                    for (var m = 0; m < buList.length; m++) {
                                        var weightingNode = buList[m];
                                        if (selectedRowId == weightingNode.ResponseList[0].BuId() && selectedColId == weightingNode.ResponseList[0].RiskAreaId()) {
                                            weightingNode.ResponseList[0].WeightingValue(weightingsvaluearray[i]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                GetTotalWeightings();
                $('#loadingMainDivOrgLevel_AML').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
   
    function buildsaveConBULWeightingsList() {
        try {
            AOLWViewModel.BULWeightingsListSave([]);
            var rows = AOLWViewModel.BusinessUnitsListW().length;
            var cols = AOLWViewModel.ControlAreaList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weightingAMLControls_' + AOLWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID() + '_' + AOLWViewModel.ControlAreaList()[j].ControlAreaId()
                    var newObj = new WeightingModel({
                        'Id': AOLWViewModel.ControlAreaList()[j].ControlAreaId(), 'BuId': AOLWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    AOLWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function buildSaveBULWeightingsList() {
        try {
            AOLWViewModel.BULWeightingsListSave([]);
            var rows = AOLWViewModel.BusinessUnitsLowestLevelList().length;
            var cols = AOLWViewModel.RiskAreaList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULweightingSANC' + i + '_' + j + '_' + AOLWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': AOLWViewModel.RiskAreaList()[j].RiskAreaId, 'BuId': AOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID,
                        'WeightingValue': $(txtid).val()
                    });
                    AOLWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }


    }
    function SaveWeightings() {
        AOLWViewModel.SaveActualButtonClick(true);
        saveConBULWeightings();
    }

    function saveConBULWeightings() {
        try {
            $('#loadingMainDivOrgLevel_AML').show();
            //$('#WeightingsTableBU').hide();
            AOLWViewModel.SaveButtonClick(true);
            var colsBUL = AOLWViewModel.ControlAreaList().length;
            var rows =  AOLWViewModel.BusinessUnitsListW().length;
            //var tableId = '#tblConWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0;
                for (var j = 0; j < rows; j++) {
                    var txtValue = $("#txt_weightingAMLControls_" + AOLWViewModel.BusinessUnitsListW()[j].BusinessUnit_ID() + "_" + AOLWViewModel.ControlAreaList()[i].ControlAreaId()).val();
                    
                    if (txtValue == "") {
                        $("#txt_weightingAMLControls_" + AOLWViewModel.BusinessUnitsListW()[j].BusinessUnit_ID() + "_" + AOLWViewModel.ControlAreaList()[i].ControlAreaId()).val(0);
                        $('#loadingMainControlsDiv').hide();
                        $('#RiskAreaTabDivMain').show();
                        break;
                    }
                    if (!$.isNumeric(txtValue)) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric values are not allowed.');
                        check = 1;
                        $('#loadingMainDivOrgLevel_AML').hide();
                        $('#WeightingsTableBU').show();
                        break;
                    }
                    else if (txtValue < 0 || txtValue > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $('#WeightingsTableBU').show();
                        $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                        $('#loadingMainDivOrgLevel_AML').hide();
                        break;
                    }
                    else {
                        sum += parseFloat(txtValue);
                    }

                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $('#loadingMainDivOrgLevel_AML').hide();
                        $('#WeightingsTableBU').show();
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('The total for weightings across business units should be 100% for control area' + AOLWViewModel.ControlAreaList()[i].ControlAreaName()+ '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                AOLWViewModel.ErrorStatus(1);
                $('#loadingMainDivOrgLevel_AML').hide();
                $('#WeightingsTableBU').show();
            }
            if (valid == 1) {
				try {
					
                    buildsaveConBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOrgListWeightingsBU?RiskAreaType="+ AOLWViewModel.AssessmentTypeId()+"&BUL_Entity_ID=" + AOLWViewModel.ClickedLevelDetailId()+"&AREA_TYPE="+AOLWViewModel.ClickedCompType(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(AOLWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id, BuId: item.BuId, WeightingValue: item.WeightingValue };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            if (AOLWViewModel.SaveActualButtonClick()) {
                                GetOrganizationalList();
                                GetCULevelWeightings();
                            }
                            $("#lblErrorAMLControls").hide();
                            $("#lblErrorAMLControls").text('');
                            logger.logSuccess('Weightings saved successfully.', 'Success', system.getModuleId(AOLWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AOLWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }



        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }

    }
    function saveBULWeightings() {
        try {
            $('#loadingMainDivOrgLevel_AML').show();
            $('#WeightingsTableBU').hide();
            AOLWViewModel.SaveButtonClick(true);
            var colsBUL = AOLWViewModel.RiskAreaList().length;
            var rows = AOLWViewModel.BusinessUnitsLowestLevelList().length;
            var tableId = '#tblSACNWeightingsBU-' + AOLWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                        break;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                        break;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).text('The total for weightings across business units should be 100% for risk area ' + AOLWViewModel.RiskAreaList()[i].RiskAreaName + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                AOLWViewModel.ErrorStatus(1);
                $('#loadingMainDivOrgLevel_AML').hide();
                $('#WeightingsTableBU').show();
            }
            if (valid == 1) {
                try {
                    buildSaveBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
						url: "/api/WeightingsThresholds/SaveOverallWeightingsBUL?RiskAreaType=" + AOLWViewModel.AssessmentTypeId() + "&BUL_Entity_ID=" + AOLWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(AOLWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id, BuId: item.BuId, WeightingValue: item.WeightingValue };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            //var mappedData = $.map(jsonResult, function (result) {
                            //    return new WeightingModel(result);
                            //});
                            AOLWViewModel.BULWeightingsList([]);
                            // AOLWViewModel.BULWeightingsList(mappedData);
                            $(tableId).remove();
                            GetBUlevelWeightings();
                            checkBULevelWeighting = 1;
                            BULevelWeightingsTable(checkBULevelWeighting);
                            GetTotalWeightingsBUL();
                            $("#lblSANCError-" + AOLWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Inherent Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(AOLWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AOLWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULWeightings() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }


    function checkDecimal(value) {
        try {
            var num = parseFloat(value);
            if (num.toFixed(1) == value) {
                return true;
            }
            return num.toFixed(2) == value;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkDecimal() method in AML OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    //------------Model Definition
    function RiskAreaModel(item) {
        var self = this;
        self.RiskAreaName = $('<div/>').html(item.RiskAreaName).text();// ko.observable($('<div/>').html(item.RiskAreaName).text());
        self.RiskAreaId = item.RiskAreaId;// ko.observable(item.RiskAreaId);
        self.RiskAreaType = $('<div/>').html(item.RiskAreaType).text();// ko.observable($('<div/>').html(item.RiskAreaType).text());
        if ($('<div/>').html(item.IsQualitative).text() == "1") {
            self.IsQualitative = true;// ko.observable(true);
        }
        else {
            self.IsQualitative = false;// ko.observable(false);
        }
    }

    function BusinessLevelModel(item) {
        var self = this;
        self.Bulevel = $('<div/>').html(item.Bulevel).text();//ko.observable($('<div/>').html(item.Bulevel).text());
        self.BlName = $('<div/>').html(item.BlName).text();//ko.observable($('<div/>').html(item.BlName).text());
        self.BlId = item.BlId;//ko.observable(item.BlId);
    }

    function BusinessLevelDetail(item) {
        var self = this;
        self.DetailId = $('<div/>').html(item.BuLevelDetailId).text();// ko.observable($('<div/>').html(item.BuLevelDetailId).text());
        self.DetailName = $('<div/>').html(item.BuLevelDetailName).text();// ko.observable($('<div/>').html(item.BuLevelDetailName).text());
        self.PreviousSavedFlag = item.PreviousSavedFlag;
        self.PreviousDetailId = $('<div/>').html(item.PreviousDetailId).text();

        AOLWViewModel.PreviousSavedFlag(item.PreviousSavedFlag);
        AOLWViewModel.PreviousSavedDetailId(item.PreviousDetailId);
    }

    function ControlAreas(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.RiskAreaId);
            var AreaName = item.AreaName;
                                if (item.AreaName.length > 17) {
                                    AreaName = item.AreaName.substring(0, 17) + '...';
                                   
                                }else{
                                    var space = item.AreaName.length;
                                    var spaceText = '';
                                        for (j = 0; j < 20 - space; j++){
                                            spaceText += '&nbsp';
                                        }
                                   AreaName = item.AreaName + spaceText;
                                }

                                self.ControlAreaName = ko.observable($('<div/>').html(AreaName).text());
                                self.ControlAreaNameTitle = ko.observable($('<div/>').html(item.AreaName).text());
            self.Rank = ko.observable($('<div/>').html(item.AMLRank).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlAreas() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnits(item) {
        var self = this;
        self.BusinessUnit_ID = item.BuId;// ko.observable(item.BuId);
        self.BusinessUnit_Name = $('<div/>').html(item.BuName).text();// ko.observable($('<div/>').html(item.BuName).text());
        self.BuAssessmentDate = $('<div/>').html(item.BuAssessmentDate).text();// ko.observable($('<div/>').html(item.BuAssessmentDate).text());
        self.BuStatus = $('<div/>').html(item.BuStatus).text();// ko.observable($('<div/>').html(item.BuStatus).text());
    }

    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuLId);
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function WeightingModel(item) {
        var self = this;
        self.Id = item.Id;// ko.observable(item.Id);
        self.BuId = item.BuId;// ko.observable(item.BuId);
        self.WeightingValue = item.WeightingValue;// ko.observable(item.WeightingValue);
        if (item.Name != undefined)
            self.Name = ko.observable(item.Name);

        if (item.BuStatus != undefined)
            self.BuStatus = ko.observable(item.BuStatus);
    }

    function WeightingDataModel(item) {
        try {
            var self = this;
            self.BuId = ko.observable($('<div/>').html(item.BuId).text());
            self.Bu_Name = ko.observable($('<div/>').html(item.Bu_Name).text());

            var MappedObject = $.map(item.AreasCountList, function (result) {
                return new AreasCountListModel(result);
            });
            self.AreasCountList = MappedObject;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function AreasCountListModel(item) {
        try {
            var self = this;
            var MappedObject = $.map(item.ResponseList, function (result) {
                return new RiskLevelModel(result);
            });
            self.ResponseList = MappedObject;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskAreaId = ko.observable($('<div/>').html(item.RiskAreaId).text());
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.BuId = ko.observable($('<div/>').html(item.BuId).text());
            self.Bu_Name = ko.observable($('<div/>').html(item.Bu_Name).text());
            self.WeightingValue = ko.observable($('<div/>').html(item.WeightingValue).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

});



































